import { Box, Typography } from "@mui/material";

const Uptime = (props: { timestamp?: Date | "not-yet-fetched" }) => {
  if (!props.timestamp) {
    return <Box></Box>;
  }
  let message = "Fetching...";
  if (props.timestamp != "not-yet-fetched") {
    message = "Lazertrader uptime: " + formatDifference(props.timestamp);
  }

  return (
    <Box>
      <Typography
        title={props.timestamp.toString()}
        variant="h6"
        sx={{ whiteSpace: "nowrap" }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export const formatDifference = (
  timestamp: Date | undefined
): string | undefined => {
  if (!timestamp) {
    return undefined;
  }
  const endDate = new Date();
  const milliseconds = endDate.getTime() - timestamp.getTime();
  const minutes = Math.floor((milliseconds / (1000 * 60)) % 60);
  const hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);
  const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));

  const parts: string[] = [];
  if (days > 0) parts.push(`${days} days`);
  if (hours > 0) parts.push(`${hours} hours`);
  parts.push(`${minutes} minutes`);

  return parts.join(", ") || "0 seconds"; // In case all are 0s
};

export { Uptime };
